export enum EIntegrationTypes {
  PUSH_ORDERS = 'PUSH_ORDERS',
}

export enum EChannelType {
  SALES_CHANNEL = 'sales_channel',
  FULFILLMENT_CHANNEL = 'fulfillment_channel',
  END_TO_END_CHANNEL = 'end_to_end_channel'
}

export const CChannelTypesLookUp = [
  {
    value: EChannelType.SALES_CHANNEL,
    label: 'Sales Channel'
  },
  {
    value: EChannelType.FULFILLMENT_CHANNEL,
    label: 'Fulfillment Channel'
  },
  {
    value: EChannelType.END_TO_END_CHANNEL,
    label: 'End to End Channel'
  }
];
